<template>
    <div class="guest__inputContainer room-info-warp cabin-item" ref="guestForm">
        <div class="room-name">
            <span class="name">客房{{index+1}}：{{stateroomName}}</span>
            <img class="c_guestInfo" src="https://resource.rcclchina.com.cn/cruiseDetail/pc/custom_info.png" v-if="isConnectRoom" @click="isShowConnectRoomPopup=true">
            <img class="c_guestInfo" src="https://resource.rcclchina.com.cn/QIAOHU/qiaohu.png" v-if="booking.groupType=='QIAOHU'" @click="isShowQiaohuPopup=true">
            <img class="c_guestInfo" src="https://resource.rcclchina.com.cn/STARRYSKY/PC/PC_icon.png" v-else-if="booking.groupType=='STARRYSKY'" @click="isShowStarrySkyPopup=true">
            <img class="c_guestInfo CUSTOM_THEME_CSS"
                 :src="booking.stateroomPartRecord.personalizedStateroomInfo?.roomIconImage"
                 v-else-if="booking.groupType=='CUSTOM' || booking.groupType=='PCPGIFT'"
                 @click="showCustomThemePopup(booking.stateroomPartRecord.personalizedStateroomInfo)">
            <span class="name-tag stateroomDetailTag" @click="showStateroomDetailPopup">舱房详情</span>
            <NrpTag
                :isNrp="booking.isnrp"
                :isFortyEightHoursNrpCruise="order.isFortyEightHoursNrpCruise"
                :index="('bookingNrpTag_'+index)"
                :direction="'right'"
                :showRow="showRow"
            />
        </div>
        <div class="room-detail">
            <div class="room-detail-floor">
              <div class="left-icon">
                <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/floor-room-pc-icon.png" alt="">
              </div>
              <span class="floor-num" v-if="booking.stateroomNumber !== 'GTY'">
                楼层：<span>{{booking.deckNumber}}层</span>
              </span>
              <span>
                  房间号：<span class="detail-room-number">{{booking.stateroomNumber == "GTY" ? "随机": booking.stateroomNumber}}</span>
                  &nbsp;&nbsp;
                  <GtyTag v-if="booking.stateroomNumber == 'GTY'"
                          :targetContainer="'app'"
                          :index="('gtyTag_'+index)"/>
              </span>
              <template v-if="showDeckImg == true">
                <template v-if="booking.stateroomNumber != 'GTY'">
                    <!--              <span v-if="is2021Sailing">如需更改房号请下单后联系客服</span>-->
                    <a class="det_text changeStateroom" style="cursor: pointer;" @click="showBookingDeck" v-if="isConnectRoom">查看甲板图</a>
                    <a class="det_text changeStateroom changeRoomNumber" style="cursor: pointer;" v-else @click="onChangeStateroomClick">房号随心选
                    <img src="https://resource.rcclchina.com.cn/mobileSearchPackage/floor-right-icon.png" alt=""> </a>
                </template>
              </template>
            </div>
            <div>
              <span>人数：<span>{{guests.length}}人</span>&nbsp;|&nbsp;</span>
              <span>
                <span>舱房：{{stateroom.areaInfo}}</span>
                &nbsp;|&nbsp;
              </span>
              <span>
                <span>{{balconyArea}}</span>
              </span>
            </div>
        </div>
        <div v-if="booking.stateroomNumberRemark" class="stateroomTips">*{{booking.stateroomNumberRemark}}</div>
        <!-- 优惠券  -->
        <div class="coupons-warp">
            <label for="coupons">优惠券 </label>
            <select name="cars" class="booking__coupon_select"
            @change="onCouponCodeSelected($event, booking.sessionToken)">
                <option value="">不选择优惠券</option>
                <option v-for="(coupon, i) in coupons" :key="('coupon_'+i)"
                :value="coupon.token"
                :selected="coupon.token==booking.couponCode">{{coupon.promotion}}</option>
            </select>
            <label for="activityCode" class="activity-code">活动码 </label>
            <input class="publicCoupon" :value="booking.publicCouponCode" type="text" placeholder="请输入活动码" @change="addPublicCouponCode($event, booking.sessionToken)">
        </div>
        <!-- 乘客信息 -->
        <template v-for="(guest, i) in guests">
          <GuestInfoGuest
              v-if="i===0"
              :guest="guest"
              :index="i"
              :key="('guest_' + i)"
              :tip-show="order.isAllowQuickOrder"
              :onGuestConfirm="onGuestConfirm"
              :onSelectContactShow="onSelectContactShow"
              @clearGuest="onClearGuest"
              :changeGuestCommon="changeGuestCommon"
          />
          <GuestInfoGuest
              v-if="i>0"
              v-show="isFold"
              :guest="guest"
              :index="i"
              :key="('guest_' + i)"
              :onGuestConfirm="onGuestConfirm"
              :onSelectContactShow="onSelectContactShow"
              :clearGuest="onClearGuest"
              :changeGuestCommon="changeGuestCommon"
          />
        </template>
        <div v-if="guests.length > 1" @click="isFold=!isFold" class="guest-fold-bar" :class="{'is-allow-quick-order': order.isAllowQuickOrder}">
          <div class="guest-fold-bar__title">
            <h3 :class="{'is-allow-quick-order': order.isAllowQuickOrder}">同行乘客信息</h3>
            <div v-if="order.isAllowQuickOrder">（建议开航<em class="fc-red">45</em>天前至“我的订单”补全，开航前<em class="fc-red">7</em>天及以内不可再进行修改）</div>
          </div>
          <img :class="{'is-open': isFold}" :src="`${imgUrl}/icons/icon-arrow-down-grey.png`"/>
        </div>


        <guest-info-special-booking
            v-if="hasSpecialBooking"
            :booking="booking"
            :specialBookingInfo="specialBookingInfo"
            :stateroomIndex="index"
        />

      <template v-if="booking.groupType==='PCPGIFT'">
        <PcpGiftView :giftInfo="booking.stateroomPartRecord?.personalizedStateroomInfo"
                     :shipCode="booking.shipCode"
                     :sailDate="booking.sailDate"
                     :guestNumber="booking.guestNumber"
                     :stateroomIndex="index"
                     @open="showCustomThemePopup"
                     is-on-page-popup
                     pageName="GuestInfo"
                     @getPcpGift="(val)=> customThemeInfo = val"></PcpGiftView>
      </template>

        <img class="connect_image"
            v-if="isFirstConnectRoom&&isConnectRoom" src="https://resource.rcclchina.com.cn/cruiseDetail/pc/connect_bg.png" alt="">

        <StateroomDetail
            v-on:onModalClose="closeStateroomDetailPopup"
            :isShow="isShowStateroomDetailPopup"
            :stateroomDetail="selectStateroom"
            :isFortyEightHoursNrpCruise="order.isFortyEightHoursNrpCruise"
            :showQiaohuPopup="showQiaohuPopup"
            :showStarrySkyPopup="showStarrySkyPopup"
            :showCustomThemePopup="showCustomThemePopup"
            :ruleDescription="specialBookingInfo.ruleDescription"
            :showRow="showRow"
        />

        <StateroomDetailSuite
            v-on:onModalClose="closeStateroomDetailSuitePopup"
            :isShow="isShowStateroomDetailSuitePopup"
            :stateroomDetail="selectStateroom"
            :isFortyEightHoursNrpCruise="order.isFortyEightHoursNrpCruise"
            :showQiaohuPopup="showQiaohuPopup"
            :showStarrySkyPopup="showStarrySkyPopup"
            :showCustomThemePopup="showCustomThemePopup"
            :showRow="showRow"
        />

        <SelectContact
            v-if="isShowSelectContact"
            is-desc
            :style="selectContactPosition"
            :onClose="onSelectContactClose"
            :limit="selectContactLimit"
            :bookingLimit="booking.guestNumber"
            :onContactConfirm="onSelectContactConfirm"
            :showQiaohuPopup="showQiaohuPopup"
            :showStarrySkyPopup="showStarrySkyPopup"
        />

        <ConnectRoomPopup
            :isShow="isShowConnectRoomPopup"
            v-on:onModalClose="isShowConnectRoomPopup=false"
        />

        <QiaohuPopup
            :isShow="isShowQiaohuPopup"
            :shipCode="booking.shipCode"
            :sailDate="booking.sailDate"
            v-on:onModalClose="isShowQiaohuPopup=false"
        />

        <StarrySkyPopup
            :isShow="isShowStarrySkyPopup"
            :shipCode="booking.shipCode"
            :sailDate="booking.sailDate"
            v-on:onModalClose="isShowStarrySkyPopup=false"
        />

        <CustomThemePopup
          :isShow="isShowCustomThemePopup"
          :themeInfo="customThemeInfo"
          v-on:onModalClose="closeCustomThemePopup"
        />

         <ChangeStateroomPopup
            :isShow="isShowChangeStateroom"
            :booking="booking"
            :cabins="targetCabins"
            v-on:onModalClose="isShowChangeStateroom=false"
            :onChangeStateroomConfirm="onChangeStateroomConfirm"
        />

      <!-- 甲板图 -->
        <BookingDeckPopup
            :isShow="isShowBookingDeck"
            v-on:onModalClose="isShowBookingDeck=false"
            :shipCode="booking.shipCode"
            :sailDate="booking.sailDate"
            :deckNumber="booking.deckNumber"
        />

    </div>
</template>

<script>
import api from '@/api'
import bookingHelper from '@/utilities/bookingHelper'
import nrpConfig from '@/utilities/nrpConfig'
import { differDays } from "@/utilities/tools";
import StarrySkyPopup from "@/components/Cruise/CruiseDetail/StarrySkyPopup.vue";
import CustomThemePopup from "@/components/Cruise/CruiseDetail/CustomThemePopup.vue";
import PcpGiftView from "@/components/PCP/PcpGiftView.vue";
const GuestInfoGuest = () => import('@/components/Booking/GuestInfo/GuestInfoGuest')
const StateroomDetail = () => import('@/components/Booking/StateroomDetail')
const StateroomDetailSuite = () => import('@/components/Booking/StateroomDetailSuite')
const NrpTag = () => import('@/components/Booking/NrpTag')
const GtyTag = () => import('@/components/Booking/GtyTag')
const SelectContact = () => import('@/components/Booking/GuestInfo/SelectContact')
const ConnectRoomPopup = () => import('@/components/Cruise/CruiseDetail/ConnectRoomPopup')
const QiaohuPopup = () => import('@/components/Cruise/CruiseDetail/QiaohuPopup')
const ChangeStateroomPopup =() => import('@/components/Booking/GuestInfo/ChangeStateroomPopup')
const BookingDeckPopup =() => import('@/components/Booking/BookingDeckPopup')
const GuestInfoSpecialBooking =() => import('@/components/Booking/GuestInfo/GuestInfoSpecialBooking')

export default {
    name: "GuestInfoStateroom",
    components: {
      PcpGiftView,
      CustomThemePopup,
      StarrySkyPopup,
        GuestInfoGuest,
        NrpTag,
        GtyTag,
        StateroomDetail,
        StateroomDetailSuite,
        SelectContact,
        ConnectRoomPopup,
        QiaohuPopup,
        ChangeStateroomPopup,
        BookingDeckPopup,
        GuestInfoSpecialBooking
    },
    props: {
        booking: {
            type: Object
        },
        coupons: {
            type: Array
        },
        bookingsOriginal: {
            type: Array
        },
        isFirstConnectRoom: {
            type: Boolean
        },
        isConnectRoom: {
            type: Boolean
        },
        index: {
            type: Number
        },
        userDetail: {
            type: Object
        },
        onCouponCodeSelected: {
            type: Function
        },
        addPublicCouponCode: {
            type: Function
        },
        showRow: {
            type: Boolean,
            default: false,
        },
        showDeckImg: {
            type: Boolean,
            default: false,
        },
        
    },
    data () {
        return {
            imgUrl: process.env.VUE_APP_IMG_URL,
            guests: [],
            isFold: true,
            selectContactTarget: {
                element: {},
                index: -1
            },
            isShowSelectContact: false,
            isShowChangeStateroom: false,
            isShowBookingDeck: false,
            isShowStateroomDetailPopup: false,
            isShowStateroomDetailSuitePopup: false,
            isShowConnectRoomPopup: false,
            isShowQiaohuPopup: false,
            isShowStarrySkyPopup: false,
            selectStateroom: {
                stateroomImages: [],
                stateroomName: '',
                stateroomCategory: '',
                stateroomPriceType: '',
                stateroomPrice: 0,
                stateroomCapacity: '',
                stateroomArea: '',
                stateroomBalcony: '',
                stateroomFloor: '',
                isQiaohu: false,
                isStarrySky: false,
                stateroomDescription: '',
                stateroomNrpTitle: '',
                stateroomNrpText: '',
                suiteMobileImageUrl: '',
                stateroomShelter: '',
                deviceFeatureTags: [],
                deviceGroupTags: []
            },
            targetCabins: [],
            ruleDescription:"",
            differDays: 0,
            isShowCustomThemePopup: false,
            customThemeInfo: null
        }
    },
    mounted () {
        this.guests = this.bookingGuests
    },
    beforeDestroy () {
        this.guests = []
    },
    methods: {
        onGuestConfirm (guest, index) {
            //覆盖乘客前判断原先乘客是否已经勾选特殊礼遇
            if(this.guests[index].specialBookingOrder != null){
                guest.specialBookingOrder = this.guests[index].specialBookingOrder
                this.guests[index] = guest
            }else{

                this.guests[index] = guest
            }
            this.onGuestContactConfirm()
        },
        checkAllGuestConfirm () {
            for (let i = 0; i < this.guests.length; i++) {
                if (!bookingHelper.checkGuestConfirm(this.guests[i])) {
                    return false
                }
            }
            return true
        },
        // 选择乘客
        async onGuestContactConfirm () {
            const guests = this.guests
            if (!guests || guests.length == 0) return
            let guestPersons = []
            for (let i = 0; i < this.guests.length; i++) {
                if (bookingHelper.checkGuestConfirm(this.guests[i])) {
                    guestPersons.push(this.guests[i])
                }
            }
            if (guestPersons.length == 0) return
            const requestData = {
                bookingKey: this.bookingKey,
                token: this.booking.sessionToken,
                guests: {
                    guestPersons
                }
            }

            // if (guests.length == guestPersons.length) {
            //     this.$loading.show()
            // }
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.addBookingGuests(requestData)
            this.$loading.hide()
            if (!success) {
                this.$alert.show(errMsg)
                console.error(errMsg)
                return
            }
            if (data && data.model && data.model.bookings) {
                let order = this.order
                let bookings = [...data.model.bookings];
                // 处理PCPGIFT价格
                bookings && bookings.forEach((row)=> {
                  order.bookings && order.bookings.forEach((oldRow)=> {
                    if(row.groupType === 'PCPGIFT' && oldRow.pcpGiftInfo){
                      row.pcpGiftInfo = oldRow.pcpGiftInfo
                    }
                  })
                })
                order.bookings = bookings
                this.$store.commit('SET_BOOKING_FUNNEL_ORDER', order)
            }
        },
        // 用户是游享荟会员，并且已经完善信息。如果订单乘客没有填写，把第一个乘客的信息用用户本人信息填上，并触发add guest 接口
        checkSetLocalRewardToFirstGuest () {
            if (this.index == 0 && this.userDetail && this.userDetail.memberLevelStr
            && this.userDetail.memberLevelStr.length > 0 && this.userDetail.infoIntegrity == 100
            && this.isGuestsEmpty) {
                let guest = this.guests[0]
                guest.pyLastName = this.userDetail.lastNamePinYin
                guest.pyFirstName = this.userDetail.firstNamePinYin
                guest.lastName = this.userDetail.lastName
                guest.firstName = this.userDetail.firstName
                guest.birthDate = this.userDetail.dateOfBirthStr
                guest.telephone = this.userDetail.mobile
                guest.gender = this.userDetail.gender
                guest.email = this.userDetail.email
                guest.passport = this.userDetail.passportNo
                guest.passportExpiresIn = this.userDetail.passportExpireStr
                guest.id = 0
                this.onGuestContactConfirm()
            }
        },
        onSelectContactShow (e, index) {
            if (this.contacts && this.contacts.length > 0) {
                this.selectContactTarget.element = e.target
                this.selectContactTarget.index = index
                this.isShowSelectContact = true
            }
        },
        onSelectContactClose () {
            this.selectContactTarget.element = null
            this.selectContactTarget.index = -1
            this.isShowSelectContact = false
        },
        onClearGuest(guest){
          console.log(guest)
        },
        onSelectContactConfirm (guests) {
            if (this.selectContactTarget.index >= 0) {
                for (let i = 0; i < guests.length; i++) {
                    guests[i].isCommonUseContact = true
                    if (this.guests.length > i + this.selectContactTarget.index) {
                        //覆盖乘客前判断原先乘客是否已经勾选特殊礼遇
                        if(this.guests[i+this.selectContactTarget.index].specialBookingOrder != null){
                            guests[i].specialBookingOrder = this.guests[i+this.selectContactTarget.index].specialBookingOrder
                            this.guests[i+this.selectContactTarget.index] = guests[i]
                        }else{

                            this.guests[i+this.selectContactTarget.index] = guests[i]
                        }
                        // this.guests[i+this.selectContactTarget.index] = guests[i]
                    }
                }

                this.onGuestContactConfirm()
            }
        },
        // 点击更换房间号，call接口获取其他可用的房间号
        async onChangeStateroomClick () {
            const booking = this.booking
            // 获取可用的房间号
            let guestAges = []
            for (let i = 0; i < booking.guestNumber; i++) {
                guestAges.push(30)
            }
            const requestData = {
                shipCode: booking.shipCode,
                sailDate: booking.sailDate,
                packageId: booking.packageId,
                fareCode: booking.fareCode,
                stateroomCategoryCode: booking.berthedCategoryCode,
                currency: 'CNY',
                guestAges: guestAges,
                agencyId: booking.agencyId,
                groupAgencyId: booking.groupAgencyId,
                groupId: booking.groupId,
                groupType: booking.groupType,
                agencyName: booking.agencyName,
                requestSequence: booking.requestSequence
            }
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.getCabins(requestData)
            this.$loading.hide()
            if (!success) {
                if (errMsg == 2000) {
                    this.goBackShoppingCart()
                    return false
                }
                this.$alert.show(errMsg)
            }
            this.targetCabins = data
            this.isShowChangeStateroom = true
        },
        // 确认更换房间号
        async onChangeStateroomConfirm (cabinNumber, deckNumber) {
            let booking = this.booking
            // 如果房间号没有变化，不需要提交
            if (booking.stateroomNumber == cabinNumber) {
                this.isShowChangeStateroom = false
                return
            }
            const requestData = {
                bookingKey: this.bookingKey,
                token: this.booking.sessionToken,
                stateroomCategoryCode: booking.berthedCategoryCode,
                stateroomNumber: cabinNumber,
                deckNumber
            }
            this.$loading.show()
            const { success, data, errMsg } = await api.booking.changeStateroomNumber(requestData)
            this.$loading.hide()
            if (!success) {
                if (errMsg == 2000) {
                    this.goBackShoppingCart()
                    return false
                }
                this.$alert.show(errMsg)
                return
            }
            booking.deckNumber = deckNumber
            booking.stateroomNumber = cabinNumber
            booking.stateroomShelter = data.stateroomShelter
            booking.stateroomNumberRemark = data.stateroomNumberRemark;
            this.$store.commit('SET_BOOKING_FUNNEL_ORDER', this.order)
            this.isShowChangeStateroom = false
        },
        // 连通房展示甲板图
        showBookingDeck() {
            const booking = this.booking
            this.targetBooking = booking
            this.isShowBookingDeck = true
        },
        closeConnectRoomPopup () {
            this.isShowConnectRoomPopup = false
        },
        // 客房详情
        showStateroomDetailPopup() {
            const booking = this.booking;
            let bookingDetail = null;
            this.bookingsOriginal && this.bookingsOriginal.forEach(r=> {
              if(r.sessionToken === booking.sessionToken) {
                bookingDetail = r;
              }
            });
            let stateroomType = booking.stateroomPartRecord.stateroomClassPartRecord.stateroomType;
            if (booking.stateroomPartRecord) {
              this.selectStateroom = {
                  stateroomImages: booking.stateroomImages,
                  stateroomName: booking.stateroomPartRecord.cnName,
                  stateroomCategory: booking.berthedCategoryCode,
                  stateroomPriceType: this.getNrpPriceType(booking),
                  stateroomPrice: (booking.netAmount / booking.guestNumber),
                  stateroomCapacity: booking.stateroomPartRecord.capacity,
                  stateroomArea: booking.stateroomPartRecord.areaInfo,
                  stateroomBalcony: booking.stateroomPartRecord.balconyAreaInfo,
                  stateroomFloor: '',
                  isQiaohu: booking.groupType == 'QIAOHU',
                  isStarrySky: booking.groupType == 'STARRYSKY',
                  isPcpGiftTheme: booking.groupType == 'PCPGIFT',
                  isCustomTheme: booking.groupType == 'CUSTOM',
                  stateroomDescription: booking.stateroomPartRecord.description,
                  stateroomNrpTitle: this.getNrpTitle(booking),
                  stateroomNrpText: this.getNrpDecription(booking),
                  suiteMobileImageUrl: booking.stateroomPartRecord.suiteMobileImageUrl,
                  stateroomShelter: booking.stateroomShelter,
                  isNrp: booking.isnrp,
                  stateroomTag: booking.stateroomPartRecord.suiteType,
                  stateroomType: stateroomType || null,
                  deviceFeatureTags: bookingDetail.featureDeviceTags,
                  deviceGroupTags: bookingDetail.deviceTags,
                  personalizedStateroomInfo: booking.stateroomPartRecord.personalizedStateroomInfo,
                  stateroomImageDataList: booking.stateroomImageDataList,
                  suiteType: booking.stateroomPartRecord.suiteType,
                  roomSummaryList: booking.roomSummaryList || [],
                  suiteRightsCount: booking.suiteRightsCount
              }
              console.log(bookingDetail)
              if(booking.groupType == "QIAOHU" || booking.groupType == "STARRYSKY" || booking.groupType == "CUSTOM" || booking.groupType == "PCPGIFT") {
                this.isShowStateroomDetailPopup = true;
              } else {
                this.isShowStateroomDetailSuitePopup = true;
              }
            }
        },
        getNrpTitle (booking) {
            if (this.isFortyEightHoursNrpCruise) return nrpConfig.fortyEightHoursNrp.title
            return booking.isnrp ? nrpConfig.nrp.title: nrpConfig.rp.title
        },
        getNrpPriceType (booking) {
            if (this.isFortyEightHoursNrpCruise) return nrpConfig.fortyEightHoursNrp.priceType
            return booking.isnrp ? nrpConfig.nrp.priceType: nrpConfig.rp.priceType
        },
        getNrpDecription (booking) {
            if (this.isFortyEightHoursNrpCruise) return nrpConfig.fortyEightHoursNrp.description
            return booking.isnrp ? nrpConfig.nrp.description: nrpConfig.rp.description
        },
        closeStateroomDetailPopup() {
            this.selectStateroom = {
                stateroomImages: [],
                stateroomName: '',
                stateroomCategory: '',
                stateroomPriceType: '',
                stateroomPrice: 0,
                stateroomCapacity: '',
                stateroomArea: '',
                stateroomBalcony: '',
                stateroomFloor: '',
                isQiaohu: false,
                isStarrySky: false,
                isPcpGiftTheme: false,
                isCustomTheme: false,
                stateroomDescription: '',
                stateroomNrpTitle: '',
                stateroomNrpText: '',
                suiteMobileImageUrl: '',
                stateroomShelter: ''
            }
            this.isShowStateroomDetailPopup = false
        },
        closeStateroomDetailSuitePopup(){
          this.selectStateroom = {
            stateroomImages: [],
            stateroomName: '',
            stateroomCategory: '',
            stateroomPriceType: '',
            stateroomPrice: 0,
            stateroomCapacity: '',
            stateroomArea: '',
            stateroomBalcony: '',
            stateroomFloor: '',
            isQiaohu: false,
            isStarrySky: false,
            isPcpGiftTheme: false,
            isCustomTheme: false,
            stateroomDescription: '',
            stateroomNrpTitle: '',
            stateroomNrpText: '',
            suiteMobileImageUrl: '',
            stateroomShelter: ''
          }
          this.isShowStateroomDetailSuitePopup = false
        },
        showQiaohuPopup () {
          this.isShowQiaohuPopup = true;
        },
        showStarrySkyPopup () {
          this.isShowStarrySkyPopup = true;
        },
        showCustomThemePopup (val) {
          this.customThemeInfo = val;
          this.isShowCustomThemePopup = true;
        },
        closeCustomThemePopup () {
          this.customThemeInfo = null;
          this.isShowCustomThemePopup = false;
        },
        changeGuestCommon(e,i){
          this.guests[i].isCommonUseContact = e
          this.onGuestContactConfirm()
        }
    },
    computed: {
        bookingKey () {
            return this.$store.state.booking.bookingKey
        },
        order () {
            return this.$store.state.booking.order
        },
        isFortyEightHoursNrpCruise () {
            return this.order.isFortyEightHoursNrpCruise
        },
        // 获取舱房对象
        stateroom () {
            if (!this.booking.stateroomPartRecord) {
                return {}
            }
            return this.booking.stateroomPartRecord
        },
        // 舱房名称
        stateroomName() {
            const stateroom = this.stateroom
            let name = stateroom.cnName + ''
            const shelter = stateroom.stateroomShelter
            if (shelter && shelter.length > 0 && name.indexOf('遮挡') < 0) {
                name += "（有遮挡）"
            }
            let code = stateroom.stateroomCategoryCode
            if (code.indexOf('_') >= 0) {
                code = code.split('_')[0]
            }
            return `${name}_${code}`
        },
        // 阳台面积，包含遮挡率
        balconyArea () {
            const stateroom = this.stateroom
            if (!stateroom.balconyAreaInfo || stateroom.balconyAreaInfo == '' || stateroom.balconyAreaInfo == '无') {
                return '无阳台'
            }
            if (stateroom.stateroomShelter && stateroom.stateroomShelter.length > 0) {
                return "(" + stateroom.stateroomShelter + "视线遮挡) " + stateroom.balconyAreaInfo
            }
            return stateroom.balconyAreaInfo
        },
        // 获取乘客
        bookingGuests () {
            const booking = this.booking
            let guests = []
            for (let i = 0; i < booking.guestNumber; i++) {
                guests.push({
                    nationality: 'CN',
                    lastName: '',
                    firstName: '',
                    pyLastName: '',
                    pyFirstName: '',
                    name: '',
                    birthDate: '',
                    passport: '',
                    passportExpiresIn: '',
                    gender: '',
                    telephone: '',
                    email: '',
                    callingCode: '86',
                    id: -1,
                    isCommonUseContact:true
                })
            }
            if(booking.guests.guestPersons && booking.guests.guestPersons.length > 0){
              booking.guests.guestPersons.forEach((guest,gIdx)=>{
                guests[gIdx].isCommonUseContact = guest.isCommonUseContact
              })
            }
            if (!booking.guests || !booking.guests.guestPersons || booking.guests.guestPersons.length == 0) {
                return guests
            }

            for (let i = 0; i < booking.guests.guestPersons.length; i++){
                guests[i] = booking.guests.guestPersons[i]
            }
            return guests
        },
        selectContactPosition () {
            if (!this.selectContactTarget || !this.selectContactTarget.element) {
                return {}
            }
            const position = this.selectContactTarget.element.getBoundingClientRect()
            const parentPos = this.$refs.guestForm.getBoundingClientRect()
            return {
                left: (position.left - parentPos.left) + 'px',
                top: (position.top - parentPos.top+20) + 'px'
            }
        },
        selectContactLimit () {
            if (!this.selectContactTarget || this.selectContactTarget.index < 0) return 1
            return this.booking.guestNumber - this.selectContactTarget.index
        },
        is2021Sailing () {
            let sailDate = this.order.sailDate
            if (!sailDate || sailDate.length < 10) return false
            sailDate = sailDate.substring(0, 10)
            const time = new Date(sailDate)
            return time.getTime() >= new Date('2021-01-01').getTime()
        },
        isGuestsEmpty () {
            return !this.guests.some(r=>r.birthDate && r.birthDate.length > 0 && r.firstName
                && r.firstName.length > 0 && r.lastName && r.lastName.length > 0 && r.pyLastName
                && r.pyLastName.length > 0 && r.pyFirstName && r.pyFirstName.length > 0)
        },
        hasSpecialBooking () {
            const order = this.$store.state.booking.order
            if (!order) {
                return {}
            }
            const specialBookingInfo = order.specialBookingInfoView || {}
            return specialBookingInfo.specialBookingViewModels && specialBookingInfo.specialBookingViewModels.length > 0
        },
        specialBookingInfo () {
            const order = this.$store.state.booking.order
            if (!order) {
                return {}
            }
            return order.specialBookingInfoView || {}
        },
        contacts () {
            return this.$store.state.user.contacts || []
        }
    },
    watch: {
        bookingGuests(newVaule) {
            this.guests = newVaule
            // 默认选择用户
            // this.checkSetLocalRewardToFirstGuest()
        },
        userDetail () {
            this.differDays = differDays(this.booking.sailDate)
            // 默认选择用户
            // this.checkSetLocalRewardToFirstGuest()
        }
    }
}
</script>

<style lang="less" scoped>
.room-info-warp {
    padding: 10px 22px 20px;
    background: #fff;
    vertical-align: 2px;
    margin-bottom: 10px;
    position: relative;
    .room-name {
        position: relative;
        span {
            display: inline-block;
        }
        .name {
            font-size: 22px;
            line-height: 48px;
            letter-spacing: 1px;
            color: #282b2c;
            margin-right: 10px;
            vertical-align: middle;
        }
        .name-tag {
            font-size: 12px;
            letter-spacing: 1px;
            color: #0073bb;
            height: 23px;
            background-color: #e7f5ff;
            border-radius: 12px;
            line-height: 23px;
            text-align: center;
            padding: 0 10px;
            cursor: pointer;
        }
        .c_guestInfo {
            cursor: pointer;
            width: 126px;
            margin-right: 5px;
            &.CUSTOM_THEME_CSS {
              width: auto;
              height: 32px;
            }
        }
        .nrp-tag {
            margin-left: 5px;
            text-decoration: underline;
        }
    }
    .room-detail {
        background: url("https://resource.rcclchina.com.cn/mobileSearchPackage/floor-pc-bg.png") no-repeat;
        background-size: 100% 100%;
        display: flex;
        align-items: center;
        padding: 10px 0 10px 10px;
        span {
            margin-right: 5px;
        }
        & .room-detail-floor{
          line-height: 19px;
          height: 19px;
          display: flex;
          font-size: 14px;
          position: relative;
          padding-left: 38px;
          color:#4a4a4a;
          & .floor-num{
            margin-right: 16px;
            span{
              font-size: 16px;
              border-bottom: 1px solid #4a4a4a;
            }
          }
          & .detail-room-number{
            font-size: 16px;
            border-bottom: 1px solid #4a4a4a;
          }
          & .left-icon{
            display: block;
            width: 25px;
            height: 25px;
            position: absolute;
            top: 50%;
            left: 0;
            transform: translateY(-50%);
          }

          & .changeStateroom{
            color: #006ab9;
            margin-right: 35px;
          }
          & .changeRoomNumber{
            display: flex;
            align-items: center;
            img{
              width: 7px;
              height: 12px;
              margin-left: 5px;
            }
          }
        }
    }
  .stateroomTips{
    font-weight: 400;
    font-size: 12px;
    color: #747d80;
    line-height: 15px;
    height: 15px;
    margin-top: 9px;
  }
    .coupons-warp {
        background-color: #fbc500;
        padding: 10px;
        margin-top: 11px;
        color: #282b2c;
        label {
            color: #282b2c;
        }
        select {
            width: 249px;
            vertical-align: middle;
            margin-left: 10px;
            height: 36px;
            background-color: #ffffff;
            border: solid 1px #d3dadd;
            padding-left: 10px;
            border-radius: 0px;
        }
        .activity-code {
            margin-left: 10px;
        }
        input {
            width: 249px;
            vertical-align: middle;
            margin-left: 10px;
            height: 36px;
            background-color: #ffffff;
            border: solid 1px #d3dadd;
        }
    }

    .connect_image {
        position: absolute;
        left: 0px;
        width: 842px;
        z-index: 1;
    }
  .guest-fold-bar {
    position: relative;
    height: 28px;
    border-radius: 28px;
    margin: 10px 0 0 23px;
    width: 704px;
    text-align: center;
    cursor: pointer;
    display: flex;
    align-items: center;
    justify-content: center;
    background-color: #F2F6F9;
    color: #778184;
    &:active {
      opacity: .6;
    }
    &.is-allow-quick-order {
      height: 42px;
      border-radius: 42px;
    }
    & .guest-fold-bar__title {
      & > h3 {
        margin: 0;
        padding-top: 2px;
        font-size: 12px;
        &.p-top-15 {
          //padding-top: 15px;
          padding-top: 2px;
        }
        &.is-allow-quick-order {
          font-size: 12px;
        }
      }
      & > div {
        font-size: 10px;
        padding-top: 2px;
        & > span {
          font-weight: bold;
        }
        & > em {
          font-style: normal;
        }
      }
    }
    & > img {
      //position: absolute;
      //top: 19px;
      //right: 155px;
      margin-left: 19px;
      &.is-open {
        transform: rotate(180deg);
      }
    }
  }
}
</style>
